/*
  Mélange les cartes des blocs « Collection en vedette » rendus en GRILLE.

  CE QUE FAIT CE FICHIER. Le serveur rend un VIVIER de cartes — plus que ce
  qui s'affiche — puis ici on les rebat et on n'en laisse voir que le nombre
  réglé dans l'éditeur. Le réglage compte donc des CARTES : « 10 » donne dix
  cartes tirées au hasard parmi toutes les variantes de la collection.

  ⚠️ ON MÉLANGE CARTE PAR CARTE, PAS PAR PRODUIT. Une première version gardait
  les coloris d'un même produit collés (« 10 boules » Rouge, Doré, Argent,
  Blanc, Pearl, puis « 30 boules » dans le même ordre). Ce n'est pas ce qu'on
  veut : le carrousel entremêle déjà les variantes de produits différents, et
  c'est ce rendu-là qui fait référence. Corrigé le 03/09/2026 sur retour de
  Quentin, capture à l'appui.

  ⚠️ ON RÉORDONNE EN CSS, ON NE DÉPLACE PAS LES NŒUDS. Une carte contient un
  élément personnalisé `<product-card>` : la sortir du DOM pour la réinsérer
  le déconnecte et relance son initialisation, qui échoue —
  « Required ref "productCardLink" not found in component product-card »,
  cinq fois, mesuré le 03/09/2026. La grille est en `display: grid`, donc
  `order` suffit.

  ⚠️⚠️ CE MESSAGE A UNE SECONDE CAUSE, SANS RAPPORT AVEC CE FICHIER, trouvée
  le 09/09/2026 : `snippets/carte-variante-couleur.liquid` rendait son ancre
  SANS l'attribut `ref="productCardLink"`. Une carte éclatée = une erreur,
  soit 46 par chargement d'accueil. ⛔ Ne pas rechercher ici un défaut de
  mélange avant d'avoir vérifié que chaque `<product-card>` porte bien son
  ancre : `document.querySelectorAll('product-card:not(:has([ref=productCardLink]))')`.

  POURQUOI CÔTÉ NAVIGATEUR. Mesuré le 03/09/2026 : une graine Liquid
  (`'now' | date: '%s'`) ne produit que DEUX ordres distincts sur 22 requêtes
  étalées sur 110 secondes, et des URL uniques n'y changent rien — l'horloge
  de Liquid n'avance pas par requête.

  Les carrousels, eux, sont mélangés par `carrousel-defilement.js`, qui doit
  le faire chez lui : il prend ses mesures de défilement juste après.
*/

const melangerGrille = (bloc, grille) => {
  const cartes = [...grille.children].filter((e) =>
    e.classList.contains('resource-list__item')
  );
  if (cartes.length < 2) return;

  // Fisher-Yates sur les cartes elles-mêmes.
  for (let i = cartes.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [cartes[i], cartes[j]] = [cartes[j], cartes[i]];
  }

  const demande = Number.parseInt(bloc.dataset.melangeVisibles, 10);
  const visibles = Number.isFinite(demande) && demande > 0 ? demande : cartes.length;

  /*
    Le quota du serveur part AVANT qu'on pose le nôtre : il masque par
    position dans le DOM, or les positions ne bougent pas — seul `order`
    change. Le garder afficherait les mauvaises cartes.
  */
  const quota = document.getElementById(bloc.dataset.melangeQuota || '');
  if (quota) quota.remove();

  cartes.forEach((carte, rang) => {
    carte.style.order = String(rang + 1);
    carte.style.display = rang < visibles ? '' : 'none';
  });
};

for (const bloc of document.querySelectorAll('[data-ordre-aleatoire]')) {
  for (const grille of bloc.querySelectorAll('.resource-list--grid')) {
    melangerGrille(bloc, grille);
  }
}
